import React from "react";
import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Breadcrumbs,
  Typography,
  Link,
  Stack,
  useMediaQuery,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";

const BackWithBreadcrumbAppbar = ({ links, currentPage }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const direction = i18n.dir();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar
      position="sticky"
      dir={direction}
      sx={{ top: isMobile ? "70px" : "100px" }}
    >
      <Toolbar variant="dense">
        <Stack
          direction="row"
          spacing={2}
          width={"100%"}
          py={1}
          justifyContent="space-between"
          alignItems="center"
        >
          <Button
            variant="containedGreen"
            size="small"
            startIcon={<ArrowBack />}
            color="inherit"
            onClick={() => navigate(-1)}
          >
            {t("Back")}
          </Button>
          <Box width={30} />
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              // Responsive font size for breadcrumb container
              fontSize: {
                xs: "0.75rem", // Mobile
                sm: "0.875rem", // Tablet
                md: "1rem", // Desktop
              },
            }}
          >
            {links.map((link, index) => {
              // Update href to include /demo prefix if it's a root path
              const href = link.href === "/" ? "/demo" : `/demo${link.href}`;

              return (
                <Link
                  key={`${link}-${index}`}
                  color={theme.palette.text.white}
                  href={href}
                  sx={{
                    // Responsive font size with mobile-first approach
                    fontSize: {
                      xs: "0.7rem", // Mobile
                      sm: "0.75rem", // Tablet
                      md: links.length > 3 ? "0.75rem" : "0.875rem", // Desktop
                    },
                    lineHeight: 1.2,
                  }}
                >
                  {t(link.label)}
                </Link>
              );
            })}
            <Typography
              color={theme.palette.text.white}
              sx={{
                // Responsive font size matching links
                fontSize: {
                  xs: "0.7rem", // Mobile
                  sm: "0.75rem", // Tablet
                  md: links.length > 3 ? "0.75rem" : "0.875rem", // Desktop
                },
                fontWeight: 500,
                lineHeight: 1.2,
              }}
            >
              {t(currentPage)}
            </Typography>
          </Breadcrumbs>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

BackWithBreadcrumbAppbar.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  currentPage: PropTypes.string.isRequired,
};

export default BackWithBreadcrumbAppbar;
